export var UserRole;
(function (UserRole) {
    UserRole["SuperAdmin"] = "super-admin";
    UserRole["Admin"] = "admin";
})(UserRole || (UserRole = {}));
